import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { portal } from '../../lib/utils/portal.ts';

var root_2 = $.from_html(`<h3 class="modal-title svelte-256swk9h1r8sf"> </h3>`);
var root_1 = $.from_html(`<div class="modal-overlay svelte-256swk9h1r8sf" tabindex="-1" role="dialog" aria-modal="true"><div class="modal-sheet svelte-256swk9h1r8sf"><div class="modal-handle svelte-256swk9h1r8sf"></div> <!> <div class="modal-body"><!></div></div></div>`);

function Modal($$anchor, $$props) {
	$.push($$props, true);

	let overlayEl;

	$.user_effect(() => {
		if ($$props.open && overlayEl) overlayEl.focus();
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var div = root_1();
			var div_1 = $.child(div);
			var node_1 = $.sibling($.child(div_1), 2);

			{
				var consequent = ($$anchor) => {
					var h3 = root_2();
					var text = $.child(h3, true);

					$.reset(h3);
					$.template_effect(() => $.set_text(text, $$props.title));
					$.append($$anchor, h3);
				};

				$.if(node_1, ($$render) => {
					if ($$props.title) $$render(consequent);
				});
			}

			var div_2 = $.sibling(node_1, 2);
			var node_2 = $.child(div_2);

			$.snippet(node_2, () => $$props.children);
			$.reset(div_2);
			$.reset(div_1);
			$.reset(div);
			$.action(div, ($$node) => portal?.($$node));
			$.bind_this(div, ($$value) => overlayEl = $$value, () => overlayEl);

			$.delegated('click', div, function (...$$args) {
				$$props.onclose?.apply(this, $$args);
			});

			$.delegated('keydown', div, (e) => {
				if (e.key === 'Escape') $$props.onclose();
			});

			$.delegated('click', div_1, (e) => e.stopPropagation());
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($$props.open) $$render(consequent_1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Modal = $.hmr(Modal);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-256swk9h1r8sf');
		Modal[$.HMR].update(module.default);
	});
}

export default Modal;

$.delegate(['click', 'keydown']);
import "bun-svelte:Modal.svelte-1ciqwuosub2o3-style.css";